import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const req = require.context('./assets/locales', false, /\.json$/);

const savedLang = localStorage.getItem("language") || "en";

const resources = {};

req.keys().forEach((fileName) => {
    const matches = fileName.match(/([a-zA-Z-]+)\.json$/);
    if (!matches) return;
    const langCode = matches[1];
    resources[langCode] = {
        translation: req(fileName),
    };
});

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: savedLang,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });
